require("./adverts.scss");